var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6673 7.17294C14.6673 6.85961 14.414 6.59961 14.094 6.59961H1.90732C1.58732 6.59961 1.33398 6.85294 1.33398 7.17294C1.33398 11.0996 4.07398 13.8396 8.00065 13.8396C11.9273 13.8396 14.6673 11.0929 14.6673 7.17294Z",
    fill: "#A586FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35294 2.30629L10.2529 4.19962C10.4463 4.39295 10.4463 4.71295 10.2529 4.90629C10.0596 5.09962 9.73961 5.09962 9.54628 4.90629L8.49961 3.86629V10.2463C8.49961 10.5196 8.27294 10.7463 7.99961 10.7463C7.72628 10.7463 7.49961 10.5196 7.49961 10.2463V3.86629L6.45961 4.91295C6.26628 5.10629 5.94628 5.10629 5.75294 4.91295C5.65294 4.81295 5.59961 4.68629 5.59961 4.55962C5.59961 4.43295 5.64628 4.30629 5.74628 4.20629L7.64628 2.31295C7.83961 2.11295 8.15961 2.11295 8.35294 2.30629Z",
    fill: "#A586FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.4e1c8ac3ce4568e762398c2772406024.svg";
export { ForwardRef as ReactComponent };